const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <p className='footer-1'>© 2023 - {new Date().getFullYear()} Y1hy11</p>
        <p className='footer-2'> Built With <span className='heart'> ❤ </span> By Y1hy11</p>
      </div>
    </footer>
  );
};

export default Footer;
